<template>
    <div>
        <AuthLayout :fo_config="fo_config" :settingsConfig="settingsConfig" :fo_content="fo_content">
            <section class="section">
                <div class="box">
                    <div class="field">
                        <label class="label">Adresse mail</label>
                        <div class="control">
                            <input type="email" class="form-control" name="" id="" v-model="email">
                        </div>
                        <p class="help is-danger">{{email_error}}</p>
                    </div>
                    <div class="field">
                        <label for="password" class="label">Nouveau mot de passe</label>
                        <div class="control">
                            <input type="password" name="" id="password" class="form-control" v-model="password">
                        </div>
                    </div>
                    <div class="field">
                        <label for="password-confirm" class="label">Confirmer le mot de passe</label>
                        <div class="control">
                            <input type="password" name="" id="password-confirm" class="form-control" v-model="password_confirm">
                        </div>
                    </div>
                    <p class="help is-danger">
                        {{ password_error }}
                    </p>
                    <div class="buttons mt-5 is-justify-content-center">
                        <button type="button" class="btn-primary1" @click="send">
                            Envoyer
                        </button>
                    </div>
                </div>
            </section>
        </AuthLayout>
    </div>
</template>

<script>
import axios from 'axios'
// import Layout from '../Layout.vue'
import AuthLayout from './AuthLayout.vue'
import {toast} from 'bulma-toast'
export default {
    name: 'ResetPassword',
    components: {AuthLayout},
    props: ['fo_config', "settingsConfig", 'fo_content', 'fo_token'],
    data () {
        return {
            email: null,
            email_error: null,
            password_error: null,
            password: null,
            password_confirm: null
        }
    },
    methods: {
        send () {
            const mail_reg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (!mail_reg.test(String(this.email).toLowerCase())) {
                this.email_error = "L'adresse mail est incorrecte."
                return false
            }
            if (!this.password || this.password.length < 5) {
                this.password_error = 'Le mot de passe doit contenir au moins 5 caractères.'
                return false
            }

            this.email_error = null
            this.password_error = null
            axios.post('/reset-password', {email: this.email, password: this.password, password_confirmation: this.password_confirm, token: this.fo_token}).then(response => {
                toast({
                    message: 'Votre mot de passe a bien été réinitialisé, Merci de vous connecter.',
                    type: 'is-success',
                    duration: 5000,
                    pauseOnHover: true
                })
                
                window.location.href = '/'
            }).catch(err => {
                let data = err?.response?.data?.errors ?? ['Une erreur est survenue, rechargez la page.']
                for (let elt in data) {
                    data[elt].map(t => {
                        toast({
                            message: t,
                            type: 'is-danger',
                            duration: 5000,
                            pauseOnHover: true
                        })
                    })
                }
            })
        },
        applyStyleVars() {
            Object.entries(this.fo_content).forEach(([key, value]) => {
                const cssVarName = `${key.replace(/_/g, '-')}`
                document.documentElement.style.setProperty(cssVarName, value)
                console.log(cssVarName);
                
            })
        },
    },
    mounted() {
        this.applyStyleVars()
        console.log('token --->', this.fo_token);
    }
}

</script>